var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNewTicket = function SvgNewTicket(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.9999,
    y: 8.62497,
    width: 1.59103,
    height: 1.59103,
    transform: "rotate(-45 11.9999 8.62497)",
    fill: "#499CE0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.74994,
    y: 6.37482,
    width: 1.59103,
    height: 1.59103,
    transform: "rotate(-45 9.74994 6.37482)",
    fill: "#499CE0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2501,
    y: 10.8748,
    width: 1.59103,
    height: 1.59103,
    transform: "rotate(-45 14.2501 10.8748)",
    fill: "#499CE0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5001,
    y: 13.1251,
    width: 1.59103,
    height: 1.59103,
    transform: "rotate(-45 16.5001 13.1251)",
    fill: "#499CE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3124 4.68732L14.25 0.749722L17.0626 3.5623C17.0626 3.56232 17.0626 3.56233 17.0626 3.56234C16.1306 4.49434 16.1306 6.00542 17.0626 6.93742C17.9946 7.86942 19.5057 7.86942 20.4377 6.93742C20.4377 6.93741 20.4377 6.9374 20.4377 6.93739L23.2503 9.74994L19.3127 13.6875L10.3124 4.68732Z",
    fill: "#499CE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18746 5.81254L0.749756 14.2502L3.5622 17.0627C3.56223 17.0627 3.56226 17.0626 3.56229 17.0626C4.49429 16.1306 6.00536 16.1306 6.93737 17.0626C7.86937 17.9946 7.86937 19.5057 6.93737 20.4377C6.93734 20.4377 6.93731 20.4377 6.93728 20.4378L9.74997 23.2505L18.1877 14.8128L9.18746 5.81254Z",
    fill: "#499CE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 19V16H20V19H23V20H20V23H19V20H16V19H19Z",
    fill: "#499CE0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNewTicket);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "new-ticket.de1de2e351a8b3cbcb478fb72d7b90e7.svg";